<template>
  <div class="iframe-container">
    <iframe
      v-if="urlDama"
      ref="damaFrame"
      :src="urlDama"
      frameborder="0"
      class="iframe-full"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import axios from 'axios';
import ccMenu from '../layout/menu.vue';
import ccFooter from '../layout/footer.vue';
import ccLoading from '../cc_geral/cc_loading.vue';

export default {
  data() {
    return {
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      urlDama: null,
    };
  },

  components: {
    ccMenu,
    ccFooter,
    ccLoading,
  },

  created() {
    document.title = 'Minha Conta: Resumo - SokkerDuel';
    localStorage.setItem("base_url_api_mobile", this.base_url_api);
  },

  mounted() {
    const userData = JSON.parse(localStorage.getItem("user"));
    this.user = userData || {};
    this.getDama();
  },

  methods: {
    getDama() {
      const body = {
        currency: "BRL",
        operator_name: "SokkerDuel",
        gameid: "damasSokkerDuel",
        language: "pt",
        token: this.user.access_token,
      };

      const header = {
        headers: {
          'x-access-token': this.user.access_token,
        },
      };

      axios.post(this.base_url_api + 'gamelaunch', body, header)
        .then(response => {
          this.urlDama = response.data.url;
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>
.iframe-container {
  /* Usa 100dvh se o navegador suportar (viewport dinâmica) */
  height: 100dvh;
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow: hidden;

  /* Garante espaço nos aparelhos com área segura (iPhones, Android com barras) */
  padding-bottom: env(safe-area-inset-bottom);
}

.iframe-full {
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dama/dama.vue